/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-handler-names */
import React, { useEffect } from 'react'
import styled from 'styled-components'
import ItemOnCart from './item'
import { useDispatch, useSelector } from 'react-redux'
import { RemoveItem } from '../../../../../flux/cart'
import { Divider, Grid } from '@material-ui/core'
import { setAlert } from '../../../../../flux/alert'
import Currency from '../../../../../helpers/currency'
import Button from '../../../../../components/inputs/ButtonLink'
import propTypes from 'prop-types'

const Summary = props => {
  const dispatch = useDispatch()
  const items = useSelector(state => state.cart)
  var idDocument = null
  var orderId = null

  useEffect(any => {
    if (props.data.methodPay === 'paypal') {
      try {
        window.document.getElementById('render_button').innerHTML = ''
        window.paypal.Buttons(paypalConfig({ ...props })).render('#render_button')
      } catch (error) {
        console.log(error)
      }
    }
  })

  const handleRemoveItem = item => {
    dispatch(setAlert({
      title: 'Quitar item del carrito',
      message: '¿Estas seguro de quitar este item del carrito?',
      action: RemoveItem(item.id)
    }))
  }

  const paypalConfig = props => {
    return {
      createOrder: async function (data, actions) {
        const { id, path, order_id } = await props.saveOperation()
        idDocument = id
        orderId = order_id
        return actions.order.create({
          purchase_units: [{
            amount: { value: props.totalPrice },
            custom_id: `${orderId}|${path}`
          }]
        })
      },
      onApprove: (data, actions) => {
        props.startProcess()
        const status = actions.order.capture().then((details) => {
          const asyncOperation = async () => {
            const { id, payer } = details
            props.successOperation({ orderId, notific: true, id: idDocument, metadata: { id, payer }, status: 'payed' })
          }
          asyncOperation()
        })
        return status
      },
      onError: (error) => {
        console.log('error:', error)
        props.endProcess()
        props.failedOperation(idDocument)
      },
      onCancel: () => {
        console.log('error:', 'cancel')
        props.endProcess()
        props.failedOperation(idDocument)
      }
    }
  }

  return (
    <Content>
      {items.map(item => (
        <ItemOnCart key={item.id} {...item} handleRemoveItem={handleRemoveItem} />
      ))}
      <Divider />
      <Group>
        <FlexBetween>
          <span>Subtotal:</span> $ {Currency.formatMoney(props.subTotal)}
        </FlexBetween>
        <FlexBetween>
          <span>Descuento por compra en línea:</span> $ -{Currency.formatMoney(props.discountAmount)} (10%)
        </FlexBetween>
        <FlexBetween>
          <span>Toma a domicilio:</span> $ {Currency.formatMoney(props.shipping)}
        </FlexBetween>
        {!!props.tax && (
          <FlexBetween>
            <span>IVA:</span> $ {Currency.formatMoney(props.tax)}
          </FlexBetween>
        )}
      </Group>
      <Divider />
      <Group>
        <FlexBetween> <span>Total:</span> $ {Currency.formatMoney(props.totalPrice)} </FlexBetween>
      </Group>
      <Grid container spacing={2}>
        {props.currentStep === 0 && (
          <Grid item xs={6}>
            <Button style={{ textTransform: 'none' }} fullWidth to='/my-cart' variant='outlined' color='primary'>Volver al carrito</Button>
          </Grid>
        )}
        {props.currentStep === 1 && (
          <Grid item xs={6}>
            <Button style={{ textTransform: 'none' }} fullWidth onClick={event => props.goToStep(0)} variant='outlined'>Volver a mis datos</Button>
          </Grid>
        )}
        {props.currentStep === 0 && (
          <Grid item xs={6}>
            <Button style={{ textTransform: 'none' }} fullWidth onClick={props.handleNext} variant='contained'>Continuar</Button>
          </Grid>
        )}
        {(props.currentStep === 1 && props.data.methodPay !== 'paypal') && (
          <Grid item xs={6}>
            <Button style={{ textTransform: 'none' }} fullWidth onClick={props.handlePay} variant='contained'>Pagar</Button>
          </Grid>
        )}
        {(props.currentStep === 1 && props.data.methodPay === 'paypal') && (
          <Grid item xs={6} style={{ position: 'relative', overflow: 'hidden' }}>
            <ButtonPaypal id='render_button' />
            <Button style={{ textTransform: 'none' }} fullWidth onClick={props.handleNext} variant='contained'>Pagar</Button>
          </Grid>
        )}
      </Grid>
    </Content>
  )
}

Summary.propTypes = {
  handleNext: propTypes.func,
  currentStep: propTypes.number,
  goToStep: propTypes.func,
  steps: propTypes.array,
  handlePay: propTypes.func,
  shipping: propTypes.number,
  totalPrice: propTypes.number,
  subTotal: propTypes.number
}

const Content = styled.div`
  margin-top: 45px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  width: 40%;
  @media screen and (max-width:700px) {
    width: 100%;
  }
`
const Group = styled.div`
  padding: 20px 0px;
`
const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.3em;
  font-weight: bold;
  & span {
    color: var(--user-gray)
  }
`

const ButtonPaypal = styled.div`
  background: red;
  width: 500px;
  height: 120%;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  opacity: 0.001;
  z-index: 10;
`

export default Summary
